export const DATE_INTERVAL = {
  day: '3',
  week: '4',
  month: '5',
  quarter: '6',
  year: '7'
}
